import { render } from "./AppFormView_21000.vue?vue&type=template&id=20bc4c0d&scoped=true"
import script from "./AppFormView_21000.vue?vue&type=script&lang=js"
export * from "./AppFormView_21000.vue?vue&type=script&lang=js"

import "./AppFormView_21000.vue?vue&type=style&index=0&id=20bc4c0d&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bc4c0d"]])

export default __exports__